function imageZoomModal() {
  return {
    isOpen: false,
    currentIndex: 0,
    allMedia: [],
    currentImageUrl: "",
    currentImageAlt: "",
    scale: 1,
    translateX: 0,
    translateY: 0,
    panX: 0, // Separate panning coordinates
    panY: 0, // Separate panning coordinates
    isPanning: false,
    lastPanX: 0,
    lastPanY: 0,
    currentZoomLevel: "100%",

    // Touch/swipe handling for mobile/tablet
    touchStartX: 0,
    touchStartY: 0,
    touchEndX: 0,
    touchEndY: 0,
    minSwipeDistance: 50, // Minimum distance for a swipe to be registered

    init() {
      this.handleEscape = this.handleEscape.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
      this.$nextTick(() => {
        this.currentZoomLevel = "100%";
      });
    },

    handleEscape(event) {
      if (event.key !== "Escape") return;
      this.close();
    },

    handleKeydown(event) {
      if (this.allMedia.length <= 1) return;

      switch (event.key) {
        case "ArrowLeft":
          event.preventDefault();
          this.previousImage();
          break;
        case "ArrowRight":
          event.preventDefault();
          this.nextImage();
          break;
        case "Escape":
          this.close();
          break;
      }
    },

    open(detail) {
      if (this.isOpen) return;

      this.currentIndex = detail.currentIndex || 0;
      this.allMedia = detail.allMedia || [];

      this.updateCurrentImage();

      this.isOpen = true;
      this.scale = 1;
      this.translateX = 0;
      this.translateY = 0;
      this.panX = 0;
      this.panY = 0;
      this.currentZoomLevel = "100%";

      window.ShopSuey.noScroll(true);
      document.addEventListener("keydown", this.handleKeydown);

      // Center the active thumbnail after the modal is rendered
      this.$nextTick(() => {
        this.centerActiveThumbnail();
      });
    },

    close() {
      if (!this.isOpen) return;

      this.isOpen = false;
      window.ShopSuey.noScroll(false);
      document.removeEventListener("keydown", this.handleKeydown);
    },

    updateCurrentImage() {
      if (this.allMedia.length === 0) return;

      const media = this.allMedia[this.currentIndex];

      if (media) {
        // Handle different media object structures
        if (media.preview_image && media.preview_image.src) {
          this.currentImageUrl = media.preview_image.src;
        } else if (media.preview_image) {
          this.currentImageUrl = media.preview_image;
        } else if (media.src) {
          this.currentImageUrl = media.src;
        } else if (media.url) {
          this.currentImageUrl = media.url;
        } else if (media.image) {
          this.currentImageUrl = media.image;
        }

        this.currentImageAlt = media.alt || media.title || "";
      }
    },

    nextImage() {
      if (this.allMedia.length <= 1) return;

      this.currentIndex = (this.currentIndex + 1) % this.allMedia.length;
      this.updateCurrentImage();
      this.resetZoom();
      this.centerActiveThumbnail();
    },

    previousImage() {
      if (this.allMedia.length <= 1) return;

      this.currentIndex = this.currentIndex === 0 ? this.allMedia.length - 1 : this.currentIndex - 1;
      this.updateCurrentImage();
      this.resetZoom();
      this.centerActiveThumbnail();
    },

    zoomIn() {
      this.scale = Math.min(this.scale * 1.2, 5);
      this.currentZoomLevel = `${Math.round(this.scale * 100)}%`;
    },

    zoomOut() {
      this.scale = Math.max(this.scale / 1.2, 1);
      this.currentZoomLevel = `${Math.round(this.scale * 100)}%`;
    },

    resetZoom() {
      this.scale = 1;
      this.translateY = 0;
      this.panX = 0; // Reset panning coordinates
      this.panY = 0; // Reset panning coordinates
      // Don't reset translateX - keep the carousel position for sliding
      this.currentZoomLevel = "100%";
    },

    handleTouchStart(event) {
      if (this.scale > 1) {
        // If zoomed in, handle as pan only
        this.startPan(event);
      } else {
        // If not zoomed, handle as swipe
        this.touchStartX = event.touches[0].clientX;
        this.touchStartY = event.touches[0].clientY;
      }
    },

    handleTouchMove(event) {
      if (this.scale > 1) {
        // If zoomed in, handle as pan only
        this.pan(event);
      }
      // If not zoomed, don't handle touch move for swipes
    },

    handleTouchEnd(event) {
      if (this.scale > 1) {
        // If zoomed in, handle as pan only - no sliding
        this.endPan();
      } else {
        // If not zoomed, handle as swipe
        this.touchEndX = event.changedTouches[0].clientX;
        this.touchEndY = event.changedTouches[0].clientY;
        this.handleSwipe();
      }
    },

    startPan(event) {
      if (this.scale <= 1) return;

      this.isPanning = true;
      const clientX = event.touches ? event.touches[0].clientX : event.clientX;
      const clientY = event.touches ? event.touches[0].clientY : event.clientY;

      this.lastPanX = clientX;
      this.lastPanY = clientY;
    },

    pan(event) {
      if (!this.isPanning || this.scale <= 1) return;

      event.preventDefault();

      const clientX = event.touches ? event.touches[0].clientX : event.clientX;
      const clientY = event.touches ? event.touches[0].clientY : event.clientY;

      const deltaX = clientX - this.lastPanX;
      const deltaY = clientY - this.lastPanY;

      // Use separate panning coordinates when zoomed in
      this.panX += deltaX;
      this.panY += deltaY;

      this.lastPanX = clientX;
      this.lastPanY = clientY;
    },

    endPan() {
      this.isPanning = false;
    },

    zoom(event) {
      if (event.deltaY < 0) {
        this.zoomIn();
      } else {
        this.zoomOut();
      }
    },

    goToImage(index) {
      if (index >= 0 && index < this.allMedia.length && index !== this.currentIndex) {
        this.currentIndex = index;
        this.updateCurrentImage();
        this.resetZoom();
        this.centerActiveThumbnail();
      }
    },

    getThumbnailUrl(media) {
      // Handle different media object structures for thumbnail URL
      let baseUrl = "";

      if (media.preview_image && media.preview_image.src) {
        baseUrl = media.preview_image.src;
      } else if (media.preview_image) {
        baseUrl = media.preview_image;
      } else if (media.src) {
        baseUrl = media.src;
      } else if (media.url) {
        baseUrl = media.url;
      } else if (media.image) {
        baseUrl = media.image;
      }

      if (!baseUrl) return "";

      // Convert to smaller thumbnail size for faster loading
      // Shopify CDN supports size parameters like ?width=100&height=100
      const url = new URL(baseUrl, window.location.origin);

      // Set small dimensions for thumbnails (60x48px)
      url.searchParams.set("width", "120"); // 2x for retina displays
      url.searchParams.set("height", "96");
      url.searchParams.set("crop", "center");

      return url.toString();
    },

    handleSwipe() {
      if (this.scale > 1) return; // Don't handle swipes when zoomed in

      const deltaX = this.touchEndX - this.touchStartX;
      const deltaY = this.touchEndY - this.touchStartY;

      // Check if it's a horizontal swipe (more horizontal than vertical)
      if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > this.minSwipeDistance) {
        if (deltaX > 0) {
          // Swipe right - go to previous image
          this.previousImage();
        } else {
          // Swipe left - go to next image
          this.nextImage();
        }
      }
    },

    centerActiveThumbnail() {
      this.$nextTick(() => {
        const thumbnailContainer = this.$refs.thumbnailContainer;
        if (!thumbnailContainer) return;

        // Find the active thumbnail button
        const activeThumbnail = thumbnailContainer.querySelector(`[data-index="${this.currentIndex}"]`);
        if (!activeThumbnail) return;

        const containerWidth = thumbnailContainer.offsetWidth;
        const thumbnailWidth = activeThumbnail.offsetWidth;
        const thumbnailLeft = activeThumbnail.offsetLeft;

        // Calculate the center position of the active thumbnail
        const thumbnailCenter = thumbnailLeft + thumbnailWidth / 2;
        const containerCenter = containerWidth / 2;
        const targetScrollLeft = thumbnailCenter - containerCenter;

        // Smooth scroll to center the active thumbnail
        thumbnailContainer.scrollTo({
          left: targetScrollLeft,
          behavior: "smooth"
        });
      });
    }
  };
}

export default imageZoomModal;
